import axios from "axios";

export function fetchCurrency() {
	return async function(dispatch, getState) {
		try {
			let accountid = getState().auth.user.accountid;
			console.log("===============fetchCurrency=====================");
			console.log({ accountid });
			console.log("====================================");
			const currency = await axios.post("/auth/account/currency", { accountid });

			console.log("===============fetchCurrency=====================");
			console.log({ currency });
			console.log("====================================");

			dispatch({ type: "SET_USER_CURRENCY", payload: currency.data.currency });
			return currency;
		} catch (err) {
			console.log("[ERROR] login action ", err);
			return err;
		}
	};
}

/** Définit le taux EUR → FCFA (optionnel, par défaut 655.957 BCEAO) */
export function setEurFcfaRate(rate) {
	return { type: "SET_EUR_FCFA_RATE", payload: rate };
}

/** Définit le taux USD → FCFA (optionnel, par défaut ~607) */
export function setUsdFcfaRate(rate) {
	return { type: "SET_USD_FCFA_RATE", payload: rate };
}

